/**
 * Created by pandemio on 3/25/19.
 */
import React from 'react';
import {Col, Row, Label} from 'reactstrap';
import {Translate} from "react-localize-redux";

/**
 * Handle the checkboxes of the countries isos
 */
class CalculationBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            costData: props.costData.costData
        };
    }

    componentWillReceiveProps(props){
        this.setState({
            costData: props.costData.costData
        })
    }

    render() {
        if(this.state.costData.PlansCosts == null)
            return null;

        let taxesStr = '';
        if(this.state.costData.PlansCosts.Taxes !== null) {
            for (let i = 0; i < this.state.costData.PlansCosts.Taxes.length; i++) {
                taxesStr += this.state.costData.PlansCosts.Taxes[i].TaxName;
            }
        }
        let intervalTranslate = "plan-calculator-form." + this.state.costData.PlansCosts.Interval;
        return(
            <Col sm={{ size: 10, offset: 1 }} md={{ size: 10, offset: 1 }} lg={{ size: 10, offset: 1 }} xs={{ size: 10, offset: 1 }}>
                <Col sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 12 }} xs={{ size: 12 }}>
                    <Label for="plan">
                        <p className="green-text">
                            <Translate id="plan-calculator-form.total-of-students" />
                            <b>{this.state.costData.PlansCosts.ProfilesQuantity}</b>
                        </p>
                    </Label>
                </Col>
                <Col className="card-gray" sm={{ size: 12}} md={{ size: 12 }} lg={{ size: 12 }} xs={{ size: 12 }}>

                    <Row>
                        <Label for="plan">
                            <b>
                                <Translate id="plan-calculator-form.total-cost" />{' ('}
                                <Translate id={intervalTranslate}/></b>{') '}
                        </Label>
                    </Row>

                    <Row>
                        <Col sm={{ size: 8 }} md={{ size: 8 }} lg={{ size: 8 }} xs={{ size: 8 }}>
                            <Translate id="plan-calculator-form.subtotal"/>
                        </Col>
                        <Col sm={{ size: 4 }} md={{ size: 4 }} lg={{ size: 4 }} xs={{ size: 4 }}>
                            { this.state.costData.PlansCosts.SubTotalWithDiscount !== null ?
                                <strike>
                                    {this.state.costData.PlansCosts.SubTotal}
                                </strike> :
                                <span>
                                    {this.state.costData.PlansCosts.SubTotal}
                                </span>
                            }
                        </Col>
                    </Row>
                    {
                        this.state.costData.PlansCosts.SubTotalWithDiscount !== null ?
                            <Row className="green-text">
                                <Col sm={{ size: 8 }} md={{ size: 8 }} lg={{ size: 8 }} xs={{ size: 8 }}>
                                    <Translate id="plan-calculator-form.subtotal-with-discount" />
                                </Col>
                                <Col sm={{ size: 4 }} md={{ size: 4 }} lg={{ size: 4 }} xs={{ size: 4 }}>
                                    {this.state.costData.PlansCosts.SubTotalWithDiscount}
                                </Col>
                            </Row> : null
                    }

                    {
                        taxesStr !== '' &&
                        (typeof this.state.costData.PlansCosts.TaxTotalWithDiscount === 'undefined'
                        || this.state.costData.PlansCosts.TaxTotalWithDiscount === null) ?
                            <Row>
                                <Col sm={{ size: 8 }} md={{ size: 8 }} lg={{ size: 8 }} xs={{ size: 8 }}>
                                    <Translate id="plan-calculator-form.taxtotal"/> {' '}
                                    <small>{taxesStr}</small>
                                </Col>
                                <Col sm={{ size: 4 }} md={{ size: 4 }} lg={{ size: 4 }} xs={{ size: 4 }}>
                                    {this.state.costData.PlansCosts.TaxTotal}
                                </Col>

                            </Row> : null
                    }
                    {
                        typeof this.state.costData.PlansCosts.TaxTotalWithDiscount !== 'undefined'
                        && this.state.costData.PlansCosts.TaxTotalWithDiscount !== null
                        && this.state.costData.PlansCosts.TaxTotalWithDiscount.length > 0
                        && this.state.costData.PlansCosts.TaxTotalWithDiscount !== "0"
                            ?
                            <Row>
                                <Col sm={{ size: 8 }} md={{ size: 8 }} lg={{ size: 8 }} xs={{ size: 8 }}>
                                    <Translate id="plan-calculator-form.taxtotal-with-discount"/> {' '}
                                    <small>{taxesStr}</small>
                                </Col>
                                <Col sm={{ size: 4 }} md={{ size: 4 }} lg={{ size: 4 }} xs={{ size: 4 }}>
                                    {this.state.costData.PlansCosts.TaxTotalWithDiscount}
                                </Col>
                            </Row>
                            : null
                    }
                    <hr/>
                    <Row>
                        <Col sm={{ size: 8 }} md={{ size: 8 }} lg={{ size: 8 }} xs={{ size: 8 }}>
                            {this.state.costData.PlansCosts.TotalWithDiscounts === null ?
                                <b><Translate id="plan-calculator-form.total"/>
                                    {' ('}
                                    <Translate id={intervalTranslate}/> {') '}</b> :
                                <strike>
                                    <b><Translate id="plan-calculator-form.total"/>
                                        {' ('}
                                        <Translate id={intervalTranslate}/> {') '}</b>
                                </strike>
                            }
                        </Col>
                        <Col sm={{ size: 4 }} md={{ size: 4 }} lg={{ size: 4 }} xs={{ size: 4 }}>
                            {this.state.costData.PlansCosts.TotalWithDiscounts === null ?
                                <b> {this.state.costData.PlansCosts.TotalCost}</b> :
                                <strike>
                                    <b> {this.state.costData.PlansCosts.TotalCost}</b>
                                </strike>
                            }
                        </Col>
                    </Row>

                    {this.state.costData.PlansCosts.TotalWithDiscounts !== null ?
                        <Row>

                            <Col sm={{ size: 8 }} md={{ size: 8 }} lg={{ size: 8 }} xs={{ size: 8 }}>
                                <b className="green-text">
                                    <Translate id="plan-calculator-form.total-with-discount"/>
                                    {' ('}
                                    <Translate id={intervalTranslate}/> {') '}</b>
                            </Col>
                            <Col sm={{ size: 4 }} md={{ size: 4 }} lg={{ size: 4 }} xs={{ size: 4 }}>
                                <b className="green-text">
                                    {this.state.costData.PlansCosts.TotalWithDiscounts}
                                </b>
                            </Col>
                        </Row> : null}
                </Col>
            </Col>
        )
    }
}

export default CalculationBox;